<template>
  <section class="page">
    <b-container>
      <b-row>
        <b-col class="col-md-6 col-sm-12">
          <vue-plotly
            v-if="chartData"
            :data="chartData"
            :layout="layout"
            class="chart"
          />
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import VuePlotly from "@statnett/vue-plotly";

export default {
  name: "OnlineServiceDataQuality",
  components: { VuePlotly },
  data() {
    return {
      chartData: [],
      layout: {
        showlegend: true,
        legend: { orientation: "h" }
      }
    };
  },
  watch: {
    countOnlineServiceAvailability: function(newVal) {
      var labels_mapping = {
        "ozg_service": "OZG Onlineservice",
        "appointment_service":
          "Terminbuchungssystem",
        "not_found": "Nicht gefunden",
        "pdf_download": "PDF Download",
        "information_service": "Informationsangebot"
      };
      var labels = [];
      var counts = [];

      for (var x in newVal) {
        labels.push(labels_mapping[newVal[x].name]);
        counts.push(newVal[x].count);
      }

      this.chartData = [
        {
          values: counts,
          labels: labels,
          type: "pie"
        }
      ];
    }
  },

  apollo: {
    $client: "ozgClient",
    countOnlineServiceAvailability: {
      query() {
        return require("../../graphql/countOnlineServiceAvailability.gql");
      }
    }
  }
};
</script>

<style scoped></style>
